export const triggerErrorMessage = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any,
  open: (content: string, type?: 'success' | 'error' | 'info') => void
) => {
  const message = error?.data?.data?.errors?.[0]?.msg || 'Something went wrong';
  open(message, 'error');
};
